import { PlaybookSvg } from "@/components/pieces/icons/svg/playbook";
import { BRAND_PURPLE } from "@/css/constants";

export function ProgramHeader() {
  return (
    <div className="bg-white border-b py-4 md:py-8">
      <div className="mx-auto max-w-[1188px] px-4">
        <div className="flex items-center">
          <PlaybookSvg size={26} color={BRAND_PURPLE} />
          <div className="ml-3">
            <h1 className="text-2xl md:text-[28px] font-semibold text-gray-900 m-0">
              Programs
            </h1>
          </div>
        </div>
        <div className="text-gray-500 mt-2">
          Create, manage, and track your programs
        </div>
      </div>
    </div>
  );
}
